import axios from '../http_v2'

let list = (data) => {
  return axios.post('opservice/tag/page', data)
}

let syslist = (data) => {
  return axios.post('opservice/tag/sys/page?size=' + data.size + '&pageNum=' + data.pageNum, data)
}

let sysPersonlist = (data) => {
  return axios.post('opservice/tag/sys/tag/listuser', data)
}

export default {
  list,
  syslist,
  sysPersonlist,
  get: 'opservice/tag/get', //根据ID查询用户标签
  save: 'opservice/tag/upsert', //保存或修改用户标签
  del: 'opservice/tag/delete', //删除用户标签(支持批量)
  taglist: 'opservice/tag/page', //分页查询用户标签
  tag: 'opservice/tag/list', //获取租户下标签
  property: 'opservice/tag/property', //获取用户标签筛选属性
  userlist: 'opservice/tag/listuser' //根据ID查询用户
}
